// extracted by mini-css-extract-plugin
module.exports = {"error":"Home_error__GeZQg","bannerCustom":"Home_bannerCustom__TAUjt"};